import { useMutation } from '@tanstack/react-query';
import type { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

import { useAxiosConfig } from '#/shared/hooks/useAxiosConfig';
import { useTimesheetStore } from '#/shared/stores/timesheetStore';

import { VerifyTimesheetApiData } from '../types/VerifyTimesheetApi';
// TODO: PPL-2240-verify-timesheet-action cleanup - Remove this default url as API will return the correct url
const DEFAULT_VERIFY_URL = '/timesheet-online-approval/verify';

export type VerifyTimesheetMutationVariables = {
  data: VerifyTimesheetApiData;
};

export const verifyTimesheet = async ({
  api,
  url,
  data,
}: { api: AxiosInstance; url: string } & VerifyTimesheetMutationVariables): Promise<AxiosResponse> => {
  return api.patch(url, data);
};

export const useVerifyTimesheetMutation = () => {
  const api = useAxiosConfig();
  const url = useTimesheetStore(state => state.links?.verify?.href ?? DEFAULT_VERIFY_URL);

  return useMutation<AxiosResponse, AxiosError, VerifyTimesheetMutationVariables>({
    mutationFn: variables => verifyTimesheet({ api, url, ...variables }),
  });
};
